(function () {
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  var isHomePage =
    window.location.pathname === '/' ||
    window.location.pathname === '' ||
    window.location.pathname === '/en' ||
    window.location.pathname === '/en/';

  var hasRealHash = window.location.hash && window.location.hash !== '#';

  if (!isHomePage || hasRealHash) return;

  var shouldKeepTop = true;

  function stopKeepTop() {
    shouldKeepTop = false;
    window.removeEventListener('touchstart', stopKeepTop);
    window.removeEventListener('wheel', stopKeepTop);
    window.removeEventListener('keydown', stopKeepTop);
  }

  function forceTop() {
    if (!shouldKeepTop) return;
    if (window.innerWidth > 768) return;

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'auto'
    });

    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  }

  window.addEventListener('touchstart', stopKeepTop, { passive: true });
  window.addEventListener('wheel', stopKeepTop, { passive: true });
  window.addEventListener('keydown', stopKeepTop);

  forceTop();

  document.addEventListener('DOMContentLoaded', function () {
    forceTop();
  });

  window.addEventListener('load', function () {
    forceTop();
    setTimeout(forceTop, 50);
    setTimeout(forceTop, 150);
    setTimeout(forceTop, 350);
    setTimeout(forceTop, 700);
    setTimeout(function () {
      forceTop();
      shouldKeepTop = false;
    }, 1200);
  });

  window.addEventListener('pageshow', function () {
    shouldKeepTop = true;
    forceTop();
    setTimeout(forceTop, 120);
    setTimeout(function () {
      shouldKeepTop = false;
    }, 600);
  });
})();

function qsIsMobile() {
  return window.matchMedia && window.matchMedia('(max-width: 768px)').matches;
}

function qsScrollIntoViewSafe(el, options) {
  if (!el || !el.scrollIntoView) return;

  if (qsIsMobile()) {
    el.scrollIntoView({
      behavior: 'auto',
      inline: options && options.inline ? options.inline : 'nearest',
      block: 'nearest'
    });
    return;
  }

  el.scrollIntoView(options || {
    behavior: 'smooth',
    inline: 'center',
    block: 'nearest'
  });
}

// Megamenu interaction
(function(){
  var navItems = document.querySelectorAll('.nav-item');
  var closeTimer = null;

  function cancelClose(){
    if (closeTimer) {
      clearTimeout(closeTimer);
      closeTimer = null;
    }
  }

  function closeAll(){
    cancelClose();
    navItems.forEach(function(it){
      it.classList.remove('open');
      var itLink = it.querySelector('a');
      if (itLink) itLink.setAttribute('aria-expanded', 'false');
    });
  }

  function scheduleClose(){
    cancelClose();
    closeTimer = setTimeout(function(){
      closeTimer = null;
      closeAll();
    }, 420);
  }

  function openItem(item){
    cancelClose();
    closeAll();
    item.classList.add('open');
    var link = item.querySelector('a');
    if (link) link.setAttribute('aria-expanded', 'true');
  }

  function canHover(){
    return window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  }

  navItems.forEach(function(item){
    var link = item.querySelector('a');
    if (!link) return;

    var hasPanel = item.querySelector('.mega-panel') || item.querySelector('.simple-panel');
    if (!hasPanel) return;

    link.setAttribute('aria-haspopup', 'true');
    link.setAttribute('aria-expanded', 'false');

    link.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();

      if (item.classList.contains('open') && !canHover()) {
        closeAll();
      } else {
        openItem(item);
      }
    });

    item.addEventListener('mouseenter', function(){
      if (canHover()) openItem(item);
    });

    item.addEventListener('mouseleave', function(){
      if (canHover()) scheduleClose();
    });

    var panel = item.querySelector('.mega-panel') || item.querySelector('.simple-panel');

    if (panel) {
      panel.addEventListener('mouseenter', function(){
        if (canHover()) cancelClose();
      });

      panel.addEventListener('mousemove', function(){
        if (canHover()) cancelClose();
      });

      panel.addEventListener('mouseleave', function(){
        if (canHover()) scheduleClose();
      });
    }
  });

  document.addEventListener('click', function(e){
    if (!e.target.closest('.nav-item')) {
      closeAll();
    }
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') closeAll();
  });
})();

// Megamenu series tab switching
(function(){
  document.querySelectorAll('.mega-series-btn').forEach(function(btn){
    btn.addEventListener('click', function(e){
      var panel = btn.closest('.mega-panel');
      var series = btn.dataset.series;

      if (!panel || !series) return;

      e.preventDefault();

      panel.querySelectorAll('.mega-series-btn').forEach(function(b){
        b.classList.remove('active');
      });

      btn.classList.add('active');

      panel.querySelectorAll('.mega-sku-panel').forEach(function(p){
        p.classList.remove('active');
      });

      var target = panel.querySelector('.mega-sku-panel[data-panel="' + series + '"]');
      if (target) target.classList.add('active');
    });
  });
})();

// Mobile navigation drawer mirrors the desktop menu hierarchy
(function(){
  var nav = document.getElementById('mobileNav');
  var openBtn = document.querySelector('[data-mobile-nav-open]');
  if (!nav || !openBtn) return;

  var closeBtns = nav.querySelectorAll('[data-mobile-nav-close]');

  function resetMobileSections(){
    nav.querySelectorAll('.mobile-nav-section').forEach(function(section){
      section.classList.remove('open');
      var toggle = section.querySelector('.mobile-nav-toggle');
      if (toggle) toggle.setAttribute('aria-expanded', 'false');
    });
  }

  function openNav(e){
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    nav.classList.add('open');
    nav.setAttribute('aria-hidden', 'false');
    document.body.classList.add('mobile-nav-lock');
  }

  function closeNav(e){
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    nav.classList.remove('open');
    nav.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('mobile-nav-lock');
    resetMobileSections();
  }

  openBtn.addEventListener('click', openNav);

  closeBtns.forEach(function(btn){
    btn.addEventListener('click', closeNav);
  });

  nav.addEventListener('click', function(e){
    if (e.target === nav) closeNav();
  });

  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') closeNav();
  });

  nav.querySelectorAll('.mobile-nav-toggle').forEach(function(toggle){
    toggle.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();

      var section = toggle.closest('.mobile-nav-section');
      var isOpen = section.classList.contains('open');

      nav.querySelectorAll('.mobile-nav-section').forEach(function(item){
        item.classList.remove('open');
        var itemToggle = item.querySelector('.mobile-nav-toggle');
        if (itemToggle) itemToggle.setAttribute('aria-expanded', 'false');
      });

      if (!isOpen) {
        section.classList.add('open');
        toggle.setAttribute('aria-expanded', 'true');
      }
    });
  });

  nav.querySelectorAll('.mobile-nav-tab').forEach(function(tab){
    tab.addEventListener('click', function(e){
      e.preventDefault();
      e.stopPropagation();

      var panel = tab.closest('.mobile-nav-panel');
      var targetName = tab.dataset.mobileSeries;

      if (!panel || !targetName) return;

      panel.querySelectorAll('.mobile-nav-tab').forEach(function(btn){
        btn.classList.remove('active');
      });

      panel.querySelectorAll('.mobile-nav-sku-panel').forEach(function(group){
        group.classList.remove('active');
      });

      tab.classList.add('active');

      var target = panel.querySelector('.mobile-nav-sku-panel[data-mobile-panel="' + targetName + '"]');
      if (target) target.classList.add('active');
    });
  });
})();

// Category tabs - hover on desktop, click on mobile
(function(){
  var tabs = document.querySelectorAll('.cat-tab');
  var panels = document.querySelectorAll('.cat-panel');
  var tabsWrap = document.querySelector('.cat-tabs-wrap');
  var tabsScroller = document.querySelector('.cat-tabs');
  var compactQuery = window.matchMedia ? window.matchMedia('(max-width: 1024px)') : null;

  function isCompact(){
    return compactQuery ? compactQuery.matches : window.innerWidth <= 1024;
  }

  function updateTabsAffordance(){
    if (!tabsWrap || !tabsScroller) return;

    var max = tabsScroller.scrollWidth - tabsScroller.clientWidth;
    var isScrollable = max > 2;
    var isAtEnd = !isScrollable || tabsScroller.scrollLeft >= max - 3;

    tabsWrap.classList.toggle('is-scrollable', isScrollable);
    tabsWrap.classList.toggle('is-at-end', isAtEnd);
  }

  function keepTabVisible(tab, immediate){
    if (!tab || !isCompact() || !tabsScroller) return;

    var tabLeft = tab.offsetLeft;
    var tabWidth = tab.offsetWidth;
    var scrollerWidth = tabsScroller.clientWidth;
    var targetLeft = tabLeft - (scrollerWidth / 2) + (tabWidth / 2);

    tabsScroller.scrollTo({
      left: Math.max(0, targetLeft),
      behavior: immediate || qsIsMobile() ? 'auto' : 'smooth'
    });

    window.setTimeout(updateTabsAffordance, immediate ? 0 : 260);
  }

  function switchTab(cat){
    tabs.forEach(function(t){
      t.classList.remove('active');
    });

    panels.forEach(function(p){
      p.classList.remove('active');
    });

    var tab = document.querySelector('.cat-tab[data-cat="' + cat + '"]');
    var panel = document.querySelector('.cat-panel[data-cat-panel="' + cat + '"]');

    if (tab) tab.classList.add('active');
    if (panel) panel.classList.add('active');

    keepTabVisible(tab, false);

    document.dispatchEvent(new CustomEvent('qlearsoul:product-panel-change', {
      detail: { cat: cat }
    }));
  }

  tabs.forEach(function(tab){
    tab.addEventListener('mouseenter', function(){
      if (window.innerWidth > 768) switchTab(tab.dataset.cat);
    });

    tab.addEventListener('click', function(){
      switchTab(tab.dataset.cat);
    });
  });

  window.addEventListener('resize', function(){
    keepTabVisible(document.querySelector('.cat-tab.active'), true);
    updateTabsAffordance();
  });

  setTimeout(function(){
    updateTabsAffordance();
  }, 0);

  if (tabsScroller) {
    tabsScroller.addEventListener('scroll', function(){
      window.requestAnimationFrame(updateTabsAffordance);
    }, { passive: true });
  }
})();

// Learn accordion: desktop hover expands, compact scroll activates and click opens.
(function(){
  var cards = document.querySelectorAll('.learn-card');
  if (!cards.length) return;

  var scroller = document.querySelector('.learn-accordion');
  var compactQuery = window.matchMedia ? window.matchMedia('(max-width: 1024px)') : null;
  var scrollFrame = null;

  function isCompact(){
    return compactQuery ? compactQuery.matches : window.innerWidth <= 1024;
  }

  function activate(card, shouldScroll){
    cards.forEach(function(c){
      c.classList.remove('active');
    });

    card.classList.add('active');

    if (shouldScroll && card.scrollIntoView) {
      qsScrollIntoViewSafe(card, {
        behavior: 'smooth',
        inline: 'center',
        block: 'nearest'
      });
    }
  }

  function activateVisibleCard(){
    if (!scroller || !isCompact()) return;

    var scrollerRect = scroller.getBoundingClientRect();
    var center = scrollerRect.left + scrollerRect.width / 2;
    var closest = null;
    var closestDistance = Infinity;

    cards.forEach(function(card){
      var rect = card.getBoundingClientRect();
      var cardCenter = rect.left + rect.width / 2;
      var distance = Math.abs(cardCenter - center);

      if (distance < closestDistance) {
        closestDistance = distance;
        closest = card;
      }
    });

    if (closest && !closest.classList.contains('active')) {
      activate(closest, false);
    }
  }

  function scheduleActiveUpdate(){
    if (scrollFrame) return;

    scrollFrame = window.requestAnimationFrame(function(){
      scrollFrame = null;
      activateVisibleCard();
    });
  }

  cards.forEach(function(card){
    card.addEventListener('mouseenter', function(){
      if (!isCompact() && (!window.matchMedia || window.matchMedia('(hover: hover)').matches)) {
        activate(card, false);
      }
    });

    card.addEventListener('click', function(e){
      if (isCompact()) {
        var href = card.getAttribute('href');

        if (href) {
          e.preventDefault();
          window.location.href = href;
        }

        return;
      }

      activate(card, false);
    });
  });

  if (scroller) {
    scroller.addEventListener('scroll', scheduleActiveUpdate, { passive: true });
    window.addEventListener('resize', scheduleActiveUpdate);

    if (compactQuery && compactQuery.addEventListener) {
      compactQuery.addEventListener('change', scheduleActiveUpdate);
    }

    setTimeout(activateVisibleCard, 0);
  }
})();

// Compact carousel dots for homepage card rows.
(function(){
  var compactQuery = window.matchMedia ? window.matchMedia('(max-width: 1024px)') : null;

  function isCompact(){
    return compactQuery ? compactQuery.matches : window.innerWidth <= 1024;
  }

  function getClosestIndex(scroller, items){
    if (!scroller || !items.length) return 0;

    var rect = scroller.getBoundingClientRect();
    var center = rect.left + rect.width / 2;
    var closestIndex = 0;
    var closestDistance = Infinity;

    items.forEach(function(item, index){
      var itemRect = item.getBoundingClientRect();
      var itemCenter = itemRect.left + itemRect.width / 2;
      var distance = Math.abs(itemCenter - center);

      if (distance < closestDistance) {
        closestDistance = distance;
        closestIndex = index;
      }
    });

    return closestIndex;
  }

  function createDotsController(config){
    var dots = document.querySelector(config.dots);
    if (!dots) return { refresh: function(){} };

    var scroller = null;
    var items = [];
    var buttons = [];
    var scrollFrame = 0;

    function findScroller(){
      return typeof config.scroller === 'function'
        ? config.scroller()
        : document.querySelector(config.scroller);
    }

    function setActive(index){
      buttons.forEach(function(button, buttonIndex){
        button.classList.toggle('is-active', buttonIndex === index);
        button.setAttribute('aria-current', buttonIndex === index ? 'true' : 'false');
      });

      items.forEach(function(item, itemIndex){
        item.classList.toggle('is-dot-active', itemIndex === index);
      });
    }

    function updateActive(){
      scrollFrame = 0;
      setActive(getClosestIndex(scroller, items));
    }

    function scheduleActive(){
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(updateActive);
    }

    function clear(){
      if (scroller) scroller.removeEventListener('scroll', scheduleActive);

      items.forEach(function(item){
        item.classList.remove('is-dot-active');
      });

      scroller = null;
      items = [];
      buttons = [];
      dots.innerHTML = '';
    }

    function refresh(){
      clear();

      scroller = findScroller();
      items = scroller ? Array.prototype.slice.call(scroller.querySelectorAll(config.itemSelector)) : [];

      if (!scroller || items.length < 2) {
        dots.hidden = true;
        return;
      }

      dots.hidden = !isCompact();

      buttons = items.map(function(item, index){
        var button = document.createElement('button');

        button.type = 'button';
        button.className = 'scroll-dot';
        button.setAttribute('aria-label', config.label + ' ' + (index + 1));

        button.addEventListener('click', function(){
          if (item.scrollIntoView) {
            qsScrollIntoViewSafe(item, {
              behavior: 'smooth',
              inline: 'center',
              block: 'nearest'
            });
          }

          setActive(index);
        });

        dots.appendChild(button);
        return button;
      });

      scroller.addEventListener('scroll', scheduleActive, { passive: true });
      window.setTimeout(scheduleActive, 0);
    }

    window.addEventListener('resize', refresh);

    if (compactQuery) {
      if (compactQuery.addEventListener) {
        compactQuery.addEventListener('change', refresh);
      } else if (compactQuery.addListener) {
        compactQuery.addListener(refresh);
      }
    }

    refresh();

    return { refresh: refresh };
  }

  var productDots = createDotsController({
    dots: '[data-scroll-dots="products"]',
    scroller: function(){
      var activePanel = document.querySelector('.cat-panel.active');
      return activePanel ? activePanel.querySelector('.cat-duo') : null;
    },
    itemSelector: '.cat-tile',
    label: 'Show product card'
  });

  document.addEventListener('qlearsoul:product-panel-change', function(){
    window.setTimeout(productDots.refresh, 0);
  });

  createDotsController({
    dots: '[data-scroll-dots="learn"]',
    scroller: '.learn-accordion',
    itemSelector: '.learn-card',
    label: 'Show learn card'
  });

  createDotsController({
    dots: '[data-scroll-dots="press"]',
    scroller: '.press-grid',
    itemSelector: '.press-card',
    label: 'Show review card'
  });
})();

// Footer accordion mobile.
(function(){
  if (window.innerWidth > 768) return;

  document.querySelectorAll('footer .col h5').forEach(function(h5){
    var ul = h5.nextElementSibling;

    h5.addEventListener('click', function(){
      var isOpen = h5.classList.contains('open');

      document.querySelectorAll('footer .col h5').forEach(function(h){
        h.classList.remove('open');
      });

      document.querySelectorAll('footer .col ul').forEach(function(u){
        u.classList.remove('open');
      });

      if (!isOpen) {
        h5.classList.add('open');
        if (ul) ul.classList.add('open');
      }
    });
  });
})();

// Reveal animation
(function(){
  var items = document.querySelectorAll('.reveal');

  if (!('IntersectionObserver' in window)) {
    items.forEach(function(el){
      el.classList.add('is-in');
    });
    return;
  }

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      if (en.isIntersecting) {
        en.target.classList.add('is-in');
        io.unobserve(en.target);
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -40px 0px'
  });

  items.forEach(function(el){
    io.observe(el);
  });
})();

// Product rows: mouse drag to scroll on desktop small screens.
// Mobile touch drag is left to the browser, so it will not fight vertical page scroll.
(function(){
  function enableDragScroll(selector){
    document.querySelectorAll(selector).forEach(function(scroller){
      if (scroller.dataset.dragScrollReady) return;
      scroller.dataset.dragScrollReady = 'true';

      scroller.querySelectorAll('img, a').forEach(function(el){
        el.setAttribute('draggable', 'false');
        el.addEventListener('dragstart', function(e){
          e.preventDefault();
        });
      });

      scroller.addEventListener('dragstart', function(e){
        e.preventDefault();
      });

      var isDown = false;
      var hasDragged = false;
      var startX = 0;
      var startScrollLeft = 0;
      var activePointerId = null;
      var dragThreshold = scroller.matches('.learn-accordion') ? 16 : 4;

      scroller.addEventListener('pointerdown', function(e){
        if (e.button !== 0) return;
        if (e.pointerType && e.pointerType !== 'mouse') return;
        if (scroller.scrollWidth <= scroller.clientWidth + 2) return;

        isDown = true;
        hasDragged = false;
        activePointerId = e.pointerId;
        startX = e.clientX;
        startScrollLeft = scroller.scrollLeft;
      });

      scroller.addEventListener('pointermove', function(e){
        if (!isDown || e.pointerId !== activePointerId) return;

        var delta = e.clientX - startX;

        if (!hasDragged && Math.abs(delta) > dragThreshold) {
          hasDragged = true;
          scroller.classList.add('is-dragging');

          if (scroller.setPointerCapture) {
            scroller.setPointerCapture(e.pointerId);
          }
        }

        if (hasDragged) {
          e.preventDefault();
          scroller.scrollLeft = startScrollLeft - delta;
        }
      });

      function endDrag(e){
        if (!isDown) return;
        if (e && activePointerId !== null && e.pointerId !== activePointerId) return;

        isDown = false;
        activePointerId = null;
        scroller.classList.remove('is-dragging');
      }

      scroller.addEventListener('pointerup', endDrag);
      scroller.addEventListener('pointercancel', endDrag);
      scroller.addEventListener('pointerleave', endDrag);

      scroller.addEventListener('click', function(e){
        if (!hasDragged) return;

        e.preventDefault();
        e.stopPropagation();
        hasDragged = false;
      }, true);
    });
  }

  enableDragScroll('.cat-duo, .support-sku-grid, .learn-accordion, .press-grid, .fans-track');
})();

// Community fan cards: slow preview scroll, pauses on hover/touch/manual scroll.
(function(){
  var tracks = document.querySelectorAll('.fans-track-real');
  if (!tracks.length) return;

  // Mobile: disable automatic preview scroll to avoid fighting vertical page scrolling.
  if (qsIsMobile()) return;

  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  tracks.forEach(function(track){
    if (track.dataset.fanPreviewReady) return;
    track.dataset.fanPreviewReady = 'true';

    var timerId = 0;
    var lastTime = 0;
    var paused = !!reducedMotion;
    var resumeTimer = 0;
    var resetPoint = 0;
    var speed = 18;

    function getResetPoint(){
      var duplicate = track.querySelector('.fan-card[aria-hidden="true"]');
      return duplicate ? duplicate.offsetLeft : Math.max(0, track.scrollWidth / 2);
    }

    function recalc(){
      resetPoint = getResetPoint();
    }

    function setPaused(value, shouldResume){
      paused = value || reducedMotion;
      track.classList.toggle('is-paused', paused);

      if (resumeTimer) {
        window.clearTimeout(resumeTimer);
        resumeTimer = 0;
      }

      if (!paused && !timerId && !reducedMotion) {
        start();
      }

      if (shouldResume && !reducedMotion) {
        resumeTimer = window.setTimeout(function(){
          paused = false;
          track.classList.remove('is-paused');
          start();
        }, 1400);
      }
    }

    function start(){
      if (timerId || reducedMotion) return;

      track.classList.add('is-auto-preview');
      lastTime = 0;
      timerId = window.setInterval(tick, 24);
    }

    function hasDirectInteraction(){
      return track.matches(':hover') || track.matches(':focus-within') || track.matches(':active');
    }

    function tick(){
      var now = window.performance ? window.performance.now() : Date.now();

      if (!lastTime) lastTime = now;

      var delta = Math.min(48, now - lastTime);
      lastTime = now;

      var directInteraction = hasDirectInteraction();

      track.classList.toggle('is-paused', paused || directInteraction);

      if (!paused && !directInteraction && track.scrollWidth > track.clientWidth + 2) {
        if (!resetPoint) recalc();

        track.scrollLeft += (speed * delta) / 1000;

        if (resetPoint && track.scrollLeft >= resetPoint) {
          track.scrollLeft = track.scrollLeft - resetPoint;
        }
      }
    }

    track.addEventListener('mouseenter', function(){
      track.classList.add('is-paused');
    });

    track.addEventListener('mouseleave', function(){
      if (!paused) track.classList.remove('is-paused');
    });

    track.addEventListener('focusin', function(){
      setPaused(true, false);
    });

    track.addEventListener('focusout', function(){
      setPaused(false, true);
    });

    track.addEventListener('pointerdown', function(){
      setPaused(true, false);
    });

    track.addEventListener('pointerup', function(){
      setPaused(true, true);
    });

    track.addEventListener('pointercancel', function(){
      setPaused(true, true);
    });

    track.addEventListener('touchstart', function(){
      setPaused(true, false);
    }, { passive: true });

    track.addEventListener('touchend', function(){
      setPaused(true, true);
    }, { passive: true });

    track.addEventListener('wheel', function(){
      setPaused(true, true);
    }, { passive: true });

    track.addEventListener('scroll', function(){
      if (track.classList.contains('is-dragging')) {
        setPaused(true, true);
      }
    }, { passive: true });

    window.addEventListener('resize', recalc);

    recalc();
    start();
  });
})();

// Footer country / region modal
(function () {
  var modal = document.querySelector('[data-region-modal]');
  var openBtn = document.querySelector('[data-region-modal-open]');
  var closeBtn = document.querySelector('[data-region-modal-close]');
  var countryForm = document.getElementById('FooterCountryForm');

  if (!modal || !openBtn || !countryForm) return;

  var countryInput = countryForm.querySelector('input[name="country_code"]');
  var previousBodyOverflow = '';

  function openModal() {
    previousBodyOverflow = document.body.style.overflow || '';
    modal.hidden = false;
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modal.hidden = true;
    document.body.style.overflow = previousBodyOverflow;
  }

  openBtn.addEventListener('click', function () {
    openModal();
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      closeModal();
    });
  }

  modal.addEventListener('click', function (event) {
    if (event.target === modal) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && !modal.hidden) {
      closeModal();
    }
  });

  modal.querySelectorAll('[data-country-code]').forEach(function (button) {
    button.addEventListener('click', function () {
      var code = button.getAttribute('data-country-code');

      if (!code || !countryInput) return;

      countryInput.value = code;
      countryForm.submit();
    });
  });
})();